// Detects both encoded and decoded email addresses. Copied from Shell team.
var emailRegex = new RegExp('[a-zA-Z0-9_\\-\\.]+(@|%40|%2540)[a-zA-Z0-9_\\-\\.]+\\.[a-zA-Z]{2,63}', 'gm');
// Tries to detect local file paths like 'file://user/path'. These often contain PII, so are scrubbed.
var localFileRegex = new RegExp('file(:|%3A|%253A).*', 'gim');
// Replaces the Search Query q paramter.
var searchQueryRegex = new RegExp('([&?]q=)(.+?)(?=[&].*| |, |$)', 'gmi');
export function filterPii(log) {
    if (!log) {
        return log;
    }
    return log
        .replace(/[\n\r\t\b]/gm, '') // remove all new lines
        .replace(emailRegex, 'email_removed')
        .replace(localFileRegex, 'file_removed')
        .replace(searchQueryRegex, '$1query_removed');
}
//# sourceMappingURL=filterPii.js.map